// extracted by mini-css-extract-plugin
export default {"usertoggle":"UserMenu_usertoggle__K2Wyd","menu":"UserMenu_menu__XGCms","triangle":"UserMenu_triangle__Sn+-M","active":"UserMenu_active__dSGnM","formlink":"UserMenu_formlink__sb3Rs"};